import { type useLocation } from '@reach/router';
import { getBasePath } from '@redneckz/wildless-cms-uni-blocks/lib/utils/getBasePath';
import { navigate } from 'gatsby';
import { ENV } from './env';

export const routerSetup = (location: ReturnType<typeof useLocation>) => () => {
  const basePath = getBasePath(ENV.SITE_URL);
  const params = new URLSearchParams(location.search);
  const query = Array.from(params.keys()).reduce(
    (sum, value) => ({ [value]: params.get(value), ...sum }),
    {},
  );

  return {
    push: (url: string) => {
      navigate(url);
    },
    replace: (url: string) => {
      navigate(url, { replace: true });
    },
    back: () => {
      globalThis.history?.back();
    },
    href: globalThis.location?.href,
    pathname: location.pathname?.replace(basePath, '').replace(/\/$/, '') || '/',
    query,
    isReady: true,
  };
};
